<template>
    <div class="container-fluid">
        <div class="card shadow p-4 py-5 h-100">
            <section class="title">{{ $t('WELCOME_CGA_TITLE') }}</section>
            <section v-dompurify-html="$t('WELCOME_CGA_TEXT')"></section>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        setPatientLanguage: function() {
            this.$store
                .dispatch("loadPatient")
                .then(patient => {
                    let patientLanguage = patient.data.language;
                    this.$store.dispatch("selectLanguage", patientLanguage);
                })
                .catch();
        }
    },
    mounted: function () {
        this.setPatientLanguage();
    }
}
</script>

<style>
</style>
